/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form } from 'antd';
import { SimulateUseCaseInterface } from 'application/usecases/SimulateUseCase';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { useAppSelector } from 'presentation/redux/hooks';
import {
    SimulateCreateCashFlowEntity,
    SimulateLoanFinancialEntity,
} from 'domain/entities/SimulateEntity';
import { openErrorNoti } from 'presentation/components/Notification';
import SelectionDynamic from 'presentation/components/SelectionDynamic';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import DropdownIcon from 'assets/icons/simulate-dropdown.svg';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { CONSTANTS } from 'utilities/constants/SIMULATE';
import { commonHelpers } from 'utilities/helpers';
import { MESSAGES_SIMULATE } from '../../../../../infrastructure/config/MESSAGES';
import InputAllowNumber from '../../CU-010-01/components/Input';
import { TAX_RATE } from 'utilities/constants/COMMON';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { ListedPropertyDetailMemberAuctionProperty } from 'domain/entities/PropertyEntity';
import { LoanSimulationEntity } from 'domain/LoanSimulationEntity';

type props = {
    purchasePrice: number;
    service: SimulateUseCaseInterface;
    propertyUseCase: PropertyUseCaseInterface;
};

const OPTION_YEAR = Array.from(Array(26).keys()).map((item) => {
    const i = item + 10;
    return {
        value: `${i}`,
        label: `${i}年`,
    };
});

const FormSimulateSale = ({ service, propertyUseCase, purchasePrice }: props) => {
    const userSlice = useAppSelector((state) => state.user);
    const NUMH = 0;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { search } = useLocation();
    const simulatorConsumptionTaxRate = TAX_RATE.INCLUDE;
    const [loanFinancial, setLoanFinancial] = React.useState<OptionEntity[]>([]);
    const [loanRefer, setLoanRefer] = React.useState<any[]>([]);
    const [fee, setFee] = React.useState<string>(commonHelpers.formatNumberMoney(NUMH));
    const [feeValue, setFeeValue] = useState(0);
    const [rent, setRent] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [thousand, setThousand] = React.useState<boolean>(false);
    const [btnDisable, setBtnDisable] = React.useState<boolean>(true);
    const [isDisalbleItem, setDisalbleItem] = useState<boolean>(true);
    const [masterFee, setMasterFee] = useState<any>();
    const [loanFinancialSelected, setLoanFinancialSelected] = useState<any>();
    const [detailAssessment, setDetailAssessment] =
        useState<ListedPropertyDetailMemberAuctionProperty>();
    const dispatch = useDispatch();
    const { listedPropertyId } = useParams();
    const onChangeForm = () => {
        const objForm = form.getFieldsValue();

        const requiredFields = [
            objForm.purchasePrice || purchasePrice || detailAssessment?.askingSalePriceUpperLimit,
            objForm.personalFunds,
            objForm.repaymentPeriod,
            objForm.rent || detailAssessment?.rent,
            objForm.commonServiceFee || detailAssessment?.commonServiceFee,
            objForm.managementFee || detailAssessment?.managementFee,
            objForm.reserveFundForRepairs || detailAssessment?.renovationDeposit,
            objForm.interestRate || loanFinancialSelected?.interestRateLowerLimit,
        ];

        const isFormComplete = requiredFields.every(field => field !== undefined && field !== '');
        setBtnDisable(!isFormComplete);
    };

    const getLoanFinancial = async () => {
        try {
            dispatch(startFetching());
            const responses = await Promise.all([
                service.getSimulateLoadFinancial(),
                service.getMasterFee(),
            ]);

            const [response, master] = responses;
            const options: OptionEntity[] = [];
            const loanOptions: LoanSimulationEntity[] = [];
            response.results.forEach((item: SimulateLoanFinancialEntity) => {

                options.push(
                    {
                        value: `${item.loanFinancialInstitutionCode}`,
                        label: `${item.financialInstitutionNameDisp}`,
                    });
                loanOptions.push({
                    value: `${item.loanFinancialInstitutionCode}`,
                    buildingAgeCriteria: `${item.buildingAgeCriteria}`,
                    expenseLowerLimit: `${item.expenseLowerLimit}`,
                    interestRateLowerLimit: `${item.loanFinancialInstitutionCode}`,
                    periodStartDate: `${item.periodStartDate}`,
                    label: `${item.financialInstitutionNameDisp}`,
                })
            });
            setMasterFee(master.result);
            setLoanFinancial(loanOptions);
            setLoanRefer(response.results);

        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };
    const ceilValue = React.useMemo(() => {
        return Math.ceil(feeValue / 100000) * 100000;
    }, [feeValue]);

    useEffect(() => {
    if (
        detailAssessment?.askingSalePriceUpperLimit ||
        purchasePrice
    ) {
        const value =
            purchasePrice ||
            detailAssessment?.askingSalePriceUpperLimit ||
            0;
        handleFee(value.toString());
    }
}, [detailAssessment, purchasePrice, masterFee]);
    const handleFee = (value: string) => {
        setFeeValue(Math.floor((Number(value) * masterFee.feeRate + masterFee.fixedFeeAmount) * simulatorConsumptionTaxRate));
        setFee(
            commonHelpers.formatNumberMoney(
                Math.floor((Number(value) * masterFee.feeRate + masterFee.fixedFeeAmount) * simulatorConsumptionTaxRate),
            ),
        );
    };

    const replace = (value: string) => {
        return value.replaceAll(',', '');
    };

    const onSubmit = async (values: any) => {
        if (isSubmitting) return; // 二重送信防止
        setIsSubmitting(true);
        try {
            const queryParams = new URLSearchParams(search);
            const param = {
                listedPropertyId: listedPropertyId,
                purchasePrice: queryParams.get('purchasePrice') || "",
                purchaseOfferId: queryParams.get('purchaseOfferId') || "",
                procedureId: queryParams.get('procedureId') || "",
                loanUseStatus: queryParams.get('loanUseStatus') || "",
            };

            const payload: SimulateCreateCashFlowEntity = {
                purchasePrice: Number(queryParams.get('purchasePrice')),
                personalFunds: Number(replace(values.personalFunds)),
                repaymentPeriod: Number(values.repaymentPeriod),
                rent: Number(replace(values.rent)),
                commonServiceFee: Number(replace(values.commonServiceFee)),
                managementFee: Number(replace(values.managementFee)),
                reserveFundForRepairs: Number(replace(values.reserveFundForRepairs)),
                loanFinancialInstitutionCode: values.loanFinancialInstitutionCode,
                periodStartDate: loanFinancialSelected?.periodStartDate,
                interestRate: Number(values.interestRate),
                buildingAge: Number(values.buildingAge),
                expense: Number(replace(values.expense)),
                otherExpenses: values.otherExpenses ? Number(replace(values.otherExpenses)) : 0,
                manualCheck: false,
                BrokerageFee: feeValue,
                includeBrokerageFee: false,
                listedPropertyId: Number(listedPropertyId),
            };
            const response = await service.createCashFlowSimWithListedProperty(payload);

            if (response) {
                payload.simId = response.result.id;
                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_058_02}?${commonHelpers.generateQueryString(param)}`, { state: payload });
            }
        } catch (error) {
            openErrorNoti();
        } finally {
            setIsSubmitting(false);
        }
    };

    const onChangeSelect = (value: string) => {
        if (value == 'manual_settings') {
            setDisalbleItem(false);
        } else {
            setDisalbleItem(true);
        }
        const destination: any = loanRefer.find(
            (item: any) => item.loanFinancialInstitutionCode === value,
        );
        setLoanFinancialSelected(destination);
        form.setFieldsValue({
            interestRate: Number(destination?.interestRateLowerLimit),
            buildingAge: Number(destination?.buildingAgeCriteria),
            expense: commonHelpers.formatNumberMoney(Number(destination?.expenseLowerLimit)),
        });
        onChangeForm();
    };
    React.useEffect(() => {
        getLoanFinancial();
        // set form init
        form.setFieldsValue({
            repaymentPeriod: '35',
        });
        (async () => {
            if (listedPropertyId) {
                await getListedPropertyRoomDetail({
                    listedPropertyId: Number(listedPropertyId),
                });
            }

        })();

    }, []);
    React.useEffect(() => {
        if (userSlice.isSignedIn) {
            form.setFieldsValue({
                repaymentPeriod: '35',
                rent: String(detailAssessment?.rent || ''),
                commonServiceFee: String(detailAssessment?.commonServiceFee || ''),
                managementFee: String(detailAssessment?.managementFee || ''),
                reserveFundForRepairs: String(detailAssessment?.renovationDeposit || ''),
                purchasePrice: String(detailAssessment?.askingSalePriceUpperLimit || ''),
                otherExpenses: String(detailAssessment?.otherExpenses01 || ''),
            });
        } else {
            form.setFieldsValue({
                purchasePrice: String(detailAssessment?.askingSalePriceUpperLimit || ''),
            });
        }
        const rent = detailAssessment?.rent ?? 0;
        setRent(rent)

        onChangeForm();
    }, [detailAssessment, masterFee]);


    const getListedPropertyRoomDetail = async (params: {
        listedPropertyId: number;
    }) => {
        try {
            dispatch(startFetching());
            const response = await propertyUseCase.getDetailAuctionOfMember(params);
            if (response) {
                console.log(response.result)
                setDetailAssessment(response.result);
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };


    const itemRules = {
        purchasePrice: [
            {
                required: true,
                message: getMessage('In_Required', '購入価格'),
            },
        ],
        personalFunds: [
            {
                required: true,
                message: getMessage('In_Required', '自己資金'),
            },
        ],
        repaymentPeriod: [
            {
                required: true,
                message: getMessage('In_Required', '返済期間'),
            },
        ],
        rent: [
            {
                required: true,
                message: getMessage('In_Required', '家賃'),
            },
        ],
        commonServiceFee: [
            {
                required: true,
                validator: (_: any, value: any) => {
                    let sanitizedValue = value?.includes?.(',') ? value.replace(/,/g, '') : value;
                    sanitizedValue = sanitizedValue == '' ? 0 : sanitizedValue;
                    const isValid =
                        sanitizedValue !== undefined &&
                        sanitizedValue !== null &&
                        sanitizedValue !== '' &&
                        !isNaN(sanitizedValue) &&
                        Number(sanitizedValue) >= 0;

                    return isValid
                        ? Promise.resolve()
                        : Promise.reject(new Error(getMessage('In_Required', '共益費')));
                },
            },
        ],
        managementFee: [
            {
                required: true,
                message: getMessage('In_Required', '管理費'),
            },
        ],
        reserveFundForRepairs: [
            {
                required: true,
                message: getMessage('In_Required', '修繕積立金'),
            },
        ],
        otherExpenses: [
            {
                required: false,
                message: getMessage('', 'その他費用'),
            },
        ],
        loanFinancialInstitutionCode: [
            {
                required: true,
                message: getMessage('In_Required', '金融機関'),
            },
        ],
        interestRate: [
            {
                required: false,
                message: getMessage('', '金利'),
            },
        ],
        buildingAge: [
            {
                required: false,
                message: getMessage('', '築年数基準'),
            },
        ],
        expense: [
            {
                required: false,
                message: getMessage('', '諸経費'),
            },
        ],
    };

    return (
        <div className="section-wrapper">
            <div className="simulate-form">
                <Form form={form} onFinish={onSubmit} onValuesChange={() => onChangeForm()} >
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                disabled={true}
                                placeholder={PLACEHOLDER.PURCHASE_PRICE}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="purchasePrice"
                                maxLength={9}
                                min={0}
                                callback={handleFee}
                                rules={itemRules.purchasePrice}
                                purchaseValue={purchasePrice}
                                label="購入価格"
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.PERSONAL_FUNDS_THOUSAND}
                                suffix={
                                    <span>
                                        {!thousand ? (
                                            <span style={{ color: '#8D9AB4' }}>1</span>
                                        ) : null}
                                        00,000円
                                    </span>
                                }
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="personalFunds"
                                maxLength={7}
                                min={0}
                                rules={itemRules.personalFunds}
                                label="自己資金"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <span>
                                返済期間<span style={{ color: '#EB5757' }}>*</span>
                            </span>

                            <SelectionDynamic
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                }}
                                icon={<img src={DropdownIcon} alt="dropdown icon" />}
                                options={OPTION_YEAR}
                                defaultValue={'35'}
                                name="repaymentPeriod"
                                messageRequired={MESSAGES_SIMULATE.REQUIRED('返済期間')}
                            />
                        </div>
                        <div className="simulate-form-input">
                            <div className="simulate-form-desc">
                                <div className="simulate-form-desc__unit">
                                    <div className="simulate-form-desc__unit-text">仲介手数料</div>
                                    <div className="simulate-form-desc__unit-amount">
                                        <span>{fee}</span> &nbsp;円
                                    </div>
                                </div>
                                <div className="simulate-form-desc__unit">
                                    <div className="simulate-form-desc__unit-text">
                                        <div>上記の仲介手数料がかかります。仲介手数料は購入価格に組み込むこともできます。詳しくはメッセージでご相談ください。</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                disabled={true}
                                placeholder={PLACEHOLDER.RENT}
                                defaultValue={(detailAssessment?.rent !== undefined || form.getFieldValue('rent') !== undefined || String(detailAssessment?.rent) === form.getFieldValue('rent')) && userSlice.isSignedIn === true ? !isNaN(Number(rent)) ? String(rent) : '' : ''}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="rent"
                                maxLength={7}
                                min={0}
                                rules={itemRules.rent}
                                label="家賃（収入）"
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                disabled={true}
                                placeholder={PLACEHOLDER.COMMON_SERVICE_FEE}
                                defaultValue={
                                   String(detailAssessment?.commonServiceFee)
                                }
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="commonServiceFee"
                                maxLength={7}
                                min={0}
                                rules={itemRules.commonServiceFee}
                                label="共益費（収入）"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                disabled={true}
                                placeholder={PLACEHOLDER.MANAGEMENT_FEE}
                                defaultValue={(detailAssessment?.managementFee !== undefined || form.getFieldValue('managementFee') !== undefined || String(detailAssessment?.managementFee) === form.getFieldValue('managementFee')) && userSlice.isSignedIn === true ? !isNaN(Number(detailAssessment?.managementFee)) ? String(detailAssessment?.managementFee) : '' : ''}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="managementFee"
                                maxLength={7}
                                min={0}
                                rules={itemRules.managementFee}
                                label="管理費（支出）"
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                disabled={true}
                                placeholder={PLACEHOLDER.RESERVE_FUND_FOR_REPAIRS}
                                defaultValue={(detailAssessment?.renovationDeposit !== undefined || form.getFieldValue('reserveFundForRepairs') !== undefined || String(detailAssessment?.renovationDeposit) === form.getFieldValue('reserveFundForRepairs')) && userSlice.isSignedIn === true ? !isNaN(Number(detailAssessment?.renovationDeposit)) ? String(detailAssessment?.renovationDeposit) : '' : ''}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="reserveFundForRepairs"
                                maxLength={7}
                                min={0}
                                rules={itemRules.reserveFundForRepairs}
                                label="修繕積立費（支出）"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                disabled={true}
                                placeholder={PLACEHOLDER.OTHER_EXPENSES}
                                defaultValue={(detailAssessment?.otherExpenses01 !== undefined || form.getFieldValue('otherExpenses') !== undefined || String(detailAssessment?.otherExpenses01) === form.getFieldValue('otherExpenses')) && userSlice.isSignedIn === true ? detailAssessment?.otherExpenses01 : ''}
                                suffix={'円'}
                                label="その他費用（インターネット使用料など）（支出）"
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                    backgroundColor: "gray !important"
                                }}
                                name="otherExpenses"
                                maxLength={7}
                                max={1000000}
                                min={0}
                                rules={itemRules.otherExpenses}
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item">
                        <div className="simulate-form-input">
                            <span>
                                金融機関<span style={{ color: '#EB5757' }}>*</span>
                            </span>
                            <SelectionDynamic
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                }}
                                icon={<img src={DropdownIcon} alt="dropdown icon" />}
                                options={loanFinancial}
                                name="loanFinancialInstitutionCode"
                                messageRequired={MESSAGES_SIMULATE.REQUIRED('金融機関')}
                                onChange={onChangeSelect}
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.INTEREST_RATE}
                                suffix={'％'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="interestRate"
                                fraction={true}
                                maxLength={4}
                                defaultValue={loanFinancialSelected?.interestRateLowerLimit ?? null}
                                min={Number(
                                    commonHelpers.formatNumberMoney(
                                        loanFinancialSelected?.interestRateLowerLimit,
                                        3,
                                    ),
                                )}
                                max={Number(
                                    commonHelpers.formatNumberMoney(
                                        loanFinancialSelected?.interestRateUpperLimit,
                                        3,
                                    ),
                                )}
                                rules={itemRules.interestRate}
                                disabled={isDisalbleItem}
                                label="金利"
                            />
                        </div>
                    </div>
                    <div className="simulate-form-item" style={{ display: 'none' }}>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.BUILDING_AGE_STANDARD}
                                suffix={'年'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="buildingAge"
                                maxLength={2}
                                max={99}
                                min={0}
                                rules={itemRules.buildingAge}
                                disabled={isDisalbleItem}
                                label="築年数基準"
                                defaultValue={loanFinancialSelected?.buildingAgeCriteria ?? null}
                            />
                        </div>
                        <div className="simulate-form-input">
                            <InputAllowNumber
                                placeholder={PLACEHOLDER.EXPENSE}
                                suffix={'円'}
                                style={{
                                    width: CONSTANTS.INPUT_WIDTH,
                                    height: CONSTANTS.INPUT_HEIGHT,
                                    border: CONSTANTS.INPUT_BORDER,
                                    color: '#000',
                                    fontSize: 14,
                                }}
                                name="expense"
                                min={Number(
                                    commonHelpers.formatNumberMoney(
                                        loanFinancialSelected?.expenseLowerLimit,
                                        3,
                                    ),
                                )}
                                max={Number(
                                    commonHelpers.formatNumberMoney(
                                        loanFinancialSelected?.expenseUpperLimit,
                                        3,
                                    ),
                                )}
                                maxLength={7}
                                rules={itemRules.expense}
                                disabled={isDisalbleItem}
                                label="諸経費"
                                defaultValue={loanFinancialSelected?.expenseLowerLimit ?? null}
                            />
                        </div>
                    </div>
                    <div>
                        ※ 利用できる金融機関は個人の属性によって変わるため詳細についてはお問合せください。
                    </div>
                    <div className="simulate-form-item">
                        <div
                            className="simulate-form-button"
                            style={{
                                cursor: `${btnDisable ? 'not-allowed' : 'pointer'}`,
                                background: `${btnDisable ? '#D0D3D8' : '#4bcae5'}`,
                            }}
                            onClick={() => (
                                !btnDisable ? form.submit() : null)
                            }
                        >
                            実行
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default FormSimulateSale;
